import { PagingData } from "src/data/types/common";
import { CoreGamingHistoryFilter } from "./CoreGamingHistoryFilter";

export class GamingHistoryRequestFilter {
	filter: CoreGamingHistoryFilter;
	paging: PagingData;
}
